export default "__VITE_ASSET__t8Oea6HY__"